export const EnvPaths = {
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  SITE_URL: process.env.REACT_APP_WEBSITE_URL,
  DASHBOARD_URL: process.env.REACT_APP_DASHBOARD_URL,
};

export const freezeScroll = () => {
  const htmlElement = document.documentElement;
  const bodyElement = document.body;

  const scrollY = window.scrollY;

  htmlElement.style.overflowY = 'hidden';
  bodyElement.style.position = 'fixed';
  bodyElement.style.top = `-${scrollY}px`;
  bodyElement.style.width = '100%';
};

export const unfreezeScroll = () => {
  const htmlElement = document.documentElement;
  const bodyElement = document.body;

  const scrollY = Math.abs(parseInt(bodyElement.style.top || '0', 10));

  htmlElement.style.overflowY = 'auto';
  bodyElement.style.position = '';
  bodyElement.style.top = '';
  bodyElement.style.width = '';

  window.scrollTo(0, scrollY);
};

export const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/; // Minimum 8 characters, at least one uppercase letter and one special character
